import React, { useState, useEffect } from "react";
import styled, { keyframes } from "styled-components";
import { FaCoins, FaHands } from "react-icons/fa"; // Import coin and clapping icons

// ✅ Keyframes for bouncing animation
const bounce = keyframes`
  0% { transform: translateY(-10px); }
  50% { transform: translateY(10px); }
  100% { transform: translateY(-10px); }
`;

// ✅ Styled Components
const StyledContainer = styled.div`
  background-color: black;
  color: white;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 20px;
`;

const AnimatedCoins = styled(FaCoins)`
  font-size: 80px;
  color: yellow;
  animation: ${bounce} 1.2s ease-in-out infinite alternate;
`;

const AnimatedClap = styled(FaHands)`
  font-size: 50px;
  color: #2ecc71;
  margin-top: 20px;
  opacity: ${(props) => (props.animate ? "1" : "0")};
  transition: opacity 0.5s ease-in-out;
`;

const StyledText = styled.h2`
  font-size: 24px;
  font-weight: bold;
  color: white;
  margin-bottom: 10px;
`;

const RewardBox = styled.div`
  font-size: 20px;
  padding: 10px;
  border: 2px solid red;
  border-radius: 8px;
  color: white;
  margin-bottom: 20px;
`;

const ContinueButton = styled.button`
  background-color: #ff7c24;
  color: white;
  font-size: 20px;
  font-weight: bold;
  padding: 12px;
  border: none;
  border-radius: 10px;
  cursor: pointer;
  width: 80%;
  max-width: 300px;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: #e66a1a;
  }
`;

const EarnCoins = ({ onContinue }) => {
  const [animateClap, setAnimateClap] = useState(false);

  useEffect(() => {
    setTimeout(() => {
      setAnimateClap(true);
    }, 1000);
  }, []);

  return (
    <StyledContainer>
      {/* ✅ Animated Coins */}
      <AnimatedCoins />

      {/* ✅ Coin Earning Message */}
      <StyledText>You have earned 10 coins</StyledText>

      {/* ✅ Motivational Animated Text */}
      <RewardBox>Good job in reaching your daily goal!</RewardBox>

      {/* ✅ Animated Clapping Hands */}
      <AnimatedClap animate={animateClap} />

      {/* ✅ Continue Button */}
      <ContinueButton onClick={onContinue}>Continue</ContinueButton>
    </StyledContainer>
  );
};

export default EarnCoins;
